(function () {
  const GOAL_CENTS = window.__FREE_SHIP_GOAL_CENTS__;

  function moneyFromCents(cents) {
    // Simple display; your Liquid text still handles translations.
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: window.Shopify?.currency?.active || "USD" });
  }

  async function refreshProgressBar() {
    const host = document.querySelector("#primary-cart-item");
    if (!host || !GOAL_CENTS) return;

    // Fetch live cart totals
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) return;
    const cart = await res.json();

    const goal = GOAL_CENTS;
const total = cart.items_subtotal_price; // or whichever basis you choose

const cappedValue = Math.min(total, goal);
const isFree = total >= goal;

const progress = document.querySelector('#primary-cart-item progress');
if (progress) {
  progress.max = goal;
  progress.value = cappedValue;   // <-- critical fix
  progress.classList.toggle('free-shipp-ready', isFree);
}


    // Update classes for styling
    const p = host.querySelector(".free-shipping");
    if (p) p.classList.toggle("success", isFree);

    // OPTIONAL: update the remaining amount if your text uses a <span> for it
    const amtSpan = host.querySelector(".free-shipping span");
    if (amtSpan && !isFree) amtSpan.textContent = moneyFromCents(remaining);
  }

  // Run on load
  document.addEventListener("DOMContentLoaded", refreshProgressBar);

  // Run after clicks on +/- and quantity input changes
  document.addEventListener("click", (e) => {
    if (e.target.closest("quantity-input")) {
      setTimeout(refreshProgressBar, 150);
    }
  });
  document.addEventListener("change", (e) => {
    if (e.target.matches('input[name="updates[]"]')) {
      setTimeout(refreshProgressBar, 150);
    }
  });
})();
